import * as React from 'react'

function IconSave(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={46}
      height={46}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30.356 42.39H15.645c-6.648 0-12.035-5.387-12.035-12.034V15.644C3.61 8.997 8.997 3.61 15.645 3.61h14.711c6.648 0 12.035 5.387 12.035 12.034v14.712c0 6.647-5.387 12.034-12.035 12.034z"
        stroke="#219321"
        strokeWidth={6}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M32.267 18.171l-9.264 9.264a3.677 3.677 0 01-5.204 0l-4.137-4.138"
        stroke="#219321"
        strokeWidth={6}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconSave
